/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentVersion { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    documentId: string;
    /**
     * Etiqueta legible de la versión (ej. 1.3)
     */
    version: string;
    versionMajor: number;
    versionMinor: number;
    /**
     * El archivo real, en folder_files con module_key = normativity
     */
    folderFileId?: string;
    /**
     * MIME real del archivo, validado contra los primeros bytes al subir. Solo application/pdf se puede abrir en el visor; el resto se descarga
     */
    mimeType?: string;
    /**
     * Tamaño en bytes del archivo en claro. Nulo en versiones cargadas antes de la columna
     */
    fileSize?: number;
    /**
     * Solo una vigente por documento (índice único parcial)
     */
    status: NormativeDocumentVersion.StatusEnum;
    /**
     * Resumen de cambios obligatorio: alimenta la línea de tiempo del documento
     */
    changeSummary: string;
    publishedOn?: string;
    /**
     * Entrada en vigor (YYYY-MM-DD), puede ser posterior a publishedOn
     */
    effectiveOn?: string;
    /**
     * Quién autorizó la normativa. Se congela al publicar, junto con approvedOn
     */
    approvedBy?: number;
    approvedOn?: string;
}
export namespace NormativeDocumentVersion {
    export type StatusEnum = 'borrador' | 'vigente' | 'obsoleta';
    export const StatusEnum = {
        Borrador: 'borrador' as StatusEnum,
        Vigente: 'vigente' as StatusEnum,
        Obsoleta: 'obsoleta' as StatusEnum
    };
}


